import { Service } from '@genial/services';
import { V1PatchBasketBasketCustomerByInteractionChannelAuditRequest } from '@genial/services/dist/apis';

import { screenName } from '../../../store/batchTicket/constants';
import { PostCustomerBasketServiceProps } from '../utils/types';

export const postCustomerBasketService = async ({
  customerItem,
  basketAdvisorOrderId,
}: PostCustomerBasketServiceProps) => {
  const { data, statusCode } = await Service.Basket.V1.postCustomer({
    screenName,
    createCustomerBasketOrderRequest: {
      basketAdvisorOrderId,
      customer: {
        account: {
          accountId: customerItem.accountId,
          accountNumber: customerItem.accountNumber,
          accountDigit: customerItem.accountDigit,
          accountStatusId: 0,
          accountTypeId: 0,
          availableBalance: customerItem.availableBalance,
          accountCompanyId: 0,
          accountAdvisorId: customerItem.advisorId,
          accountPartnerId: customerItem.partnerId,
        },
        customerCpfCnpj: customerItem.cpfCnpj,
        customerId: customerItem.customerId,
        customerName: customerItem.name,
        suitabilityProfileName: customerItem.suitabilityProfileName,
        professionalInvestor: customerItem.professionalInvestor,
        qualifiedInvestor: customerItem.qualifiedInvestor,
        hashTags: customerItem?.tags || [],
      },
      side: 'C',
      notification: { notificationChannels: ['whatsapp'] },
    },
  });

  if (statusCode === 201) {
    return data;
  }

  throw new Error('Não foi possível processar a requisição.');
};

export const deleteCustomerBasketService = async (basketCustomerOrderId: string) => {
  const { statusCode } = await Service.Basket.V1.deleteCustomerBasketCustomerId({
    screenName,
    basketCustomerOrderId,
  });

  return statusCode === 200;
};

export const cleanCustomersBasketService = async (basketAdvisorOrderId: string) => {
  const { statusCode } = await Service.Basket.V1.deleteBasketAdvisorIdByCleanCustomers({
    screenName,
    basketAdvisorOrderId,
  });

  return statusCode === 200;
};

export const getCustomerBalance = async (accountNumber: number) => {
  const { data } = await Service.Balance.V2.getByAccountNumber({
    screenName,
    accountNumber,
  });

  return data.balance.availableBalance ?? 0;
};

export const updateBasketCustomerInteractionChannel = async (
  params: V1PatchBasketBasketCustomerByInteractionChannelAuditRequest
) => {
  const { data } = await Service.Basket.V1.patchBasketCustomerByInteractionChannelAudit({
    ...params,
    screenName,
  });

  return data.basketCustomerOrder;
};
